<template>
  <ul class="list-group">
    <template v-if="isLoading">
      <li
        v-for="n in 5"
        :key="'skeleton-' + n"
        class="list-group-item placeholder-glow"
      >
        <div class="device-content">
          <span class="placeholder col-4"></span>
          <span class="placeholder col-3"></span>
        </div>
        <div class="meta-info">
          <span class="placeholder col-2"></span>
          <span class="placeholder col-3"></span>
          <span class="placeholder col-4"></span>
        </div>
      </li>
    </template>

    <template v-else>
      <li
        v-for="device in devices"
        :key="device.id"
        class="list-group-item"
        :class="device.active ? 'border-left-success' : 'border-left-danger'"
      >
        <div class="row align-items-center">
          <div class="col-md-1 d-none d-md-block">
            <img
              :src="getThumbnailUrl(device.setting?.img_screen)"
              class="img-thumbnail template-thumb"
              :alt="device.name"
              @click="$emit('view', device)"
            />
          </div>

          <div class="col-md-7 col-sm-12">
            <div class="mb-3">
              <strong class="device-name">#{{ device.id }} {{ device.name }}</strong>
            </div>

            <div class="meta-info">
              <span>
                <i class="bi bi-cash-coin align-middle"></i> Price:
                {{ device.price.default_unit / 10 }} GEL
              </span>
              <span>
                <i class="bi bi-tag align-middle"></i> Type:
                {{ device.device_type }}
              </span>
              <span>
                <i class="bi bi-ui-checks align-middle"></i> Template ID:
                {{ device.template_id }}
              </span>
              <span>
                <i class="bi bi-stack align-middle"></i> Paper:
                <span :class="getPaperStatus(device.paper)">{{ device.paper }}</span>
              </span>
            </div>

            <div class="meta-info second-line">
              <span>
                <i class="bi bi-clock-history align-middle"></i> Last Seen:
                {{ device.last_seen }}
              </span>
              <span>
                <i class="bi bi-calendar-check align-middle"></i> Registered:
                {{ device.regdate }}
              </span>
            </div>
          </div>

          <div class="col-md-4 d-none d-md-flex flex-column align-items-end">
            <span
              class="badge status-badge"
              :class="device.active ? 'bg-success' : 'bg-danger'"
            >
              <i
                :class="device.active ? 'bi bi-check-circle-fill' : 'bi bi-exclamation-triangle-fill'"
              ></i>
              {{ device.active ? 'Active' : 'Inactive' }}
            </span>

            <div class="action-icons mt-4">
              <button class="btn btn-sm btn-outline-secondary me-2" @click="$emit('view', device)">
                <i class="bi bi-eye"></i>
              </button>
              <button class="btn btn-sm btn-outline-secondary" @click="$emit('edit', device)">
                <i class="bi bi-pencil"></i>
              </button>
              <button class="btn btn-sm btn-outline-secondary ms-2" @click="$emit('delete', device)">
                <i class="bi bi-trash"></i>
              </button>
            </div>
          </div>
        </div>

        <div class="row d-md-none mt-2">
          <div class="col-4 text-start">
            <span
              class="badge status-badge"
              :class="device.active ? 'bg-success' : 'bg-danger'"
            >
              <i
                :class="device.active ? 'bi bi-check-circle-fill' : 'bi bi-exclamation-triangle-fill'"
              ></i>
              {{ device.active ? 'Active' : 'Inactive' }}
            </span>
          </div>
          <div class="col-8 text-end">
            <button class="btn btn-sm btn-outline-secondary me-2" @click="$emit('view', device)">
              <i class="bi bi-eye"></i>
            </button>
            <button class="btn btn-sm btn-outline-secondary me-2" @click="$emit('edit', device)">
              <i class="bi bi-pencil"></i>
            </button>
            <button class="btn btn-sm btn-outline-secondary" @click="$emit('delete', device)">
              <i class="bi bi-trash"></i>
            </button>
          </div>
        </div>
      </li>
    </template>
  </ul>
</template>

<script>
export default {
  props: {
    devices: Array,
    isLoading: Boolean,
  },
  methods: {
    getPaperStatus(paper) {
      if (paper === 0) return "text-danger fw-bold";
      if (paper < 50) return "text-warning";
      return "text-success";
    },
    getThumbnailUrl(path) {
      return path ? process.env.VUE_APP_TEMPLATE_THUMBNAIL_URL + path : '';
    },
  },
};
</script>

<style scoped>
.list-group {
  background: #ffffff;
  border-radius: 8px;
  overflow-y: auto;
  height: 85vh;
}

.list-group-item {
  font-size: 1rem;
  padding: 12px 16px;
  transition: background 0.3s ease;
  display: flex;
  flex-direction: column;
  gap: 6px;
  border-left: 5px solid transparent;
  background: #f8f9fa;
}

.list-group-item:last-child {
  margin-bottom: 40px;
}

.border-left-success {
  border-left-color: #28a745 !important;
}

.border-left-danger {
  border-left-color: #dc3545 !important;
}

.list-group-item:hover {
  background: rgba(0, 0, 0, 0.05);
}

.device-name {
  font-weight: bold;
  font-size: 1.1rem;
}

.status-badge {
  padding: 6px 10px;
  font-size: 0.85rem;
  font-weight: bold;
  border-radius: 12px;
  min-width: 80px;
  text-align: center;
}

.meta-info {
  display: flex;
  flex-wrap: wrap;
  gap: 15px;
  align-items: center;
}

.second-line {
  margin-top: 5px;
}

.action-icons button {
  width: 36px;
}

.nh {
  height: inherit !important;
  width: 98%;
}

.image-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.75);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1060;
}

.preview-image {
  max-width: 90%;
  max-height: 90%;
  border-radius: 10px;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.5);
}

.preview-close {
  position: absolute;
  top: 20px;
  right: 30px;
  color: white;
  background: transparent;
  border: none;
  font-size: 1.5rem;
  z-index: 1061;
}

.bi-eye {
  opacity: 0.5;
  transition: opacity 0.2s ease;
}

.bi-eye:hover {
  opacity: 1;
}

.template-thumb {
  width: 100%;
  height: auto;
  cursor: pointer;
  object-fit: contain;
  background-color: #ffffff;
  border: 1px solid #dee2e6;
}

@media (max-width: 768px) {
  .action-icons {
    display: flex;
    justify-content: flex-end;
    gap: 10px;
  }
}
</style>
